module.exports = __webpack_public_path__ + "img/task_active.1da783ba.svg";